import {
  EditorialIngredientsBlock,
  EditorialPanel,
  EditorialPillarsBlock,
  EditorialSpecTableBlock,
} from "../editorial";

/**
 * Detalles · paso 2 · Qué lleva dentro.
 *
 * Los pilares (por qué importa), los ingredientes (qué lleva y para qué)
 * y la tabla nutrimental (cuánto lleva de cada cosa). Es el mismo dato
 * contado con tres niveles de detalle, y quien lo escribe lo tiene
 * delante a la vez: sale todo del mismo envase y de la misma ficha del
 * laboratorio.
 */
export function CompositionStep() {
  return (
    <EditorialPanel
      title="Qué lleva"
      description="La composición, de lo general a lo concreto. Ninguno es obligatorio."
    >
      {(locale) => (
        <>
          <EditorialPillarsBlock locale={locale} />
          <EditorialIngredientsBlock locale={locale} />
          <EditorialSpecTableBlock locale={locale} />
        </>
      )}
    </EditorialPanel>
  );
}
